import axios from 'axios';
import {
  LOTTERY_SHARED_TICKET_LIST_REQUEST,
  LOTTERY_SHARED_TICKET_LIST_SUCCESS,
  LOTTERY_SHARED_TICKET_LIST_FAILURE,
  LOTTERY_SHARED_TICKET_LIST_RESET,
  LOTTERY_SHARED_TICKET_DETAIL_REQUEST,
  LOTTERY_SHARED_TICKET_DETAIL_SUCCESS,
  LOTTERY_SHARED_TICKET_DETAIL_FAILURE,
  LOTTERY_SHARED_TICKET_DETAIL_RESET,
  LOTTERY_SHARED_TICKET_BUY_REQUEST,
  LOTTERY_SHARED_TICKET_BUY_SUCCESS,
  LOTTERY_SHARED_TICKET_BUY_FAILURE,
  ACCEPT_LOTTERY_CONTRACT
} from 'Store/constants';
import errorMessage from 'Store/actions/errorMessage';
import { openModal, closeModal, updateUserBalance } from 'Store/actions';
import ProjectConfig from 'ProjectConfig';

const API_GATEWAY = ProjectConfig.API_GATEWAY;

export const getLotterySharedTicketList = () => async dispatch => {
  try {
    dispatch({
      type: LOTTERY_SHARED_TICKET_LIST_REQUEST
    });

    const res = await axios({
      url: `${API_GATEWAY}/lottery/common-tickets/packets`,
      method: 'get'
    });

    dispatch({
      type: LOTTERY_SHARED_TICKET_LIST_SUCCESS,
      payload: res.data
    });

  } catch (e) {

    dispatch({
      type: LOTTERY_SHARED_TICKET_LIST_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};

export const resetLotterySharedTicketList = () => dispatch => {
  dispatch({
    type: LOTTERY_SHARED_TICKET_LIST_RESET
  });
};

export const getLotterySharedTicketDetail = packetId => async dispatch => {
  try {
    dispatch({
      type: LOTTERY_SHARED_TICKET_DETAIL_REQUEST
    });

    const res = await axios({
      url: `${API_GATEWAY}/lottery/common-tickets/packets/${packetId}`,
      method: 'get'
    });

    dispatch({
      type: LOTTERY_SHARED_TICKET_DETAIL_SUCCESS,
      payload: res.data
    });

  } catch (e) {

    dispatch({
      type: LOTTERY_SHARED_TICKET_DETAIL_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};

export const resetLotterySharedTicketDetail = () => dispatch => {
  dispatch({
    type: LOTTERY_SHARED_TICKET_DETAIL_RESET
  });
};

export const buyLotterySharedTicket = (packetId, shareCount) => async (dispatch, getState) => {
  try {
    dispatch({
      type: LOTTERY_SHARED_TICKET_BUY_REQUEST
    });

    dispatch(openModal('sharedLotteryBuyLoader'));


    const res = await axios({
      url: `${API_GATEWAY}/lottery/common-tickets/purchase`,
      method: 'post',
      data: { packetId, shareCount, channel: 'WEB' }
    });

    dispatch({
      type: LOTTERY_SHARED_TICKET_BUY_SUCCESS,
      payload: res.data
    });

    dispatch(closeModal('sharedLotteryBuyLoader'));

    dispatch(openModal('sharedLotteryBuySuccess'));

    dispatch(updateUserBalance());

    const { isCommonTicketAgreementAccepted } = getState().auth.data;
    if (!isCommonTicketAgreementAccepted) {
      dispatch({ type: ACCEPT_LOTTERY_CONTRACT });
    }

  } catch (e) {

    const { code } = e.response && e.response.data || {};
    dispatch(closeModal('sharedLotteryBuyLoader'));

    dispatch({
      type: LOTTERY_SHARED_TICKET_BUY_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });

    if (code === 4004) {
      dispatch(openModal('sharedLotteryBalanceNotEnough'));
    } else {
      dispatch(openModal('sharedLotteryBuyFailure', { error: e.response && e.response.data }));
    }

  }

};

export const getLatestCommonTicketAgreement = () => dispatch => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await axios({
        url: `${API_GATEWAY}/cms/userAgreement/latestCommonTicketAgreement`,
        method: 'get'
      });

      resolve(res);
    } catch (e) {
      reject(e);
    }
  });
};
